/* eslint-disable no-console */
import ReportStore from './ReportStore'
import AuthStore from './AuthStore'
import ChartStore from './ChartStore'
import { makeAutoObservable } from 'mobx'
import packageJson from '../../package.json'
import WizardStore from './WizardStore'
import CommentStore from './CommentStore'
import SearchStore from './SearchStore'
import ProductStore from './ProductStore'
import { configurePersistable } from 'mobx-persist-store'
import AccessControlStore from './AccessControlStore'
import OptionsTableStore from './OptionsTableStore'
import FilterStore from './FilterStore'
import PlanStore from './PlanStore'
import DropzoneStore from './DropzoneStore'

configurePersistable(
  {
    storage: window.localStorage,
    expireIn: 86400000,
    removeOnExpiration: true,
    stringify: true,
    debugMode: false,
  },
  { delay: 200, fireImmediately: false },
)

class RootStore {
  confirmDialogProps = {}
  planStore = {}
  reportStore = {}
  constructor() {
    makeAutoObservable(this)
    this.reportStore = new ReportStore(this)
    this.authStore = new AuthStore(this)
    this.wizardStore = new WizardStore(this)
    this.chartStore = new ChartStore(this)
    this.commentStore = new CommentStore(this)
    this.searchStore = new SearchStore(this)
    this.productsStore = new ProductStore(this)
    this.accessControlStore = new AccessControlStore(this)
    this.optionsTableStore = new OptionsTableStore(this)
    this.filterStore = new FilterStore(this)
    this.planStore = new PlanStore(this)
    this.dropzoneStore = new DropzoneStore(this)

    console.log(`UI: v${packageJson.version}`)
    window.version = function () {
      console.log(`UI: v${packageJson.version}`)
    }
  }

  get version() {
    return packageJson.version
  }

  setConfirmDialogProps = confirmDialogProps => {
    this.confirmDialogProps = confirmDialogProps
  }

  setCurrentReport = reportId => {
    this.currentReport = { report: { id: reportId } }
  }

  //TODO: implement
  //eslint-disable-next-line @typescript-eslint/no-empty-function
  archiveReportTicket = () => {
    console.log('archiveReportTicket')
  }
  //eslint-disable-next-line @typescript-eslint/no-empty-function
  editReportTicket = () => {}
  //eslint-disable-next-line @typescript-eslint/no-empty-function
  generateReportTicket = () => {}
  //eslint-disable-next-line @typescript-eslint/no-empty-function
  approveReportTicket = () => {}
}

export default new RootStore()
